import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-slate-900 border-t border-slate-800" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <div className="mb-10" data-id="element-65">
          <h3 className="text-xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-66">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <CountdownTimer data-id="element-67" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-68">
          <div className="bg-slate-950 border border-slate-800 rounded-2xl p-6 text-left" data-id="element-69">
            <h4 className="text-xl font-black text-white mb-1" data-id="element-70">
              📘 NUEVO NIVEL — COMBO TDAH COMPLETO
            </h4>
            <p className="text-slate-400 text-sm mb-4" data-id="element-71">
              6 Tomos + 6 Bonos · Todos los niveles
            </p>
            <div className="flex justify-between items-end mb-4" data-id="element-72">
              <span className="text-slate-500 line-through text-sm" data-id="element-73">
                Valor real: $46.000
              </span>
              <span className="text-3xl font-black text-white" data-id="element-74">
                $19.990 <span className="text-sm text-slate-500" data-id="element-75">ARS</span>
              </span>
            </div>
            <a href="https://www.nuevonivel.shop/cart/49840985538800:1" className="block text-center w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-black py-3 rounded-xl transition-colors" data-id="element-76">
              → QUIERO MI COMBO
            </a>
          </div>

          <div className="bg-slate-950 border border-amber-500/30 rounded-2xl p-6 text-left relative" data-id="element-77">
            <div className="absolute -top-3 right-4 bg-amber-400 text-slate-950 text-xs font-black px-2 py-1 rounded" data-id="element-78">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="text-xl font-black text-white mb-1" data-id="element-79">
              🏆 NUEVO NIVEL + PROTOCOLO 30 DÍAS
            </h4>
            <p className="text-slate-400 text-sm mb-4" data-id="element-80">
              6 Tomos + 6 Bonos + Plan de Implementación
            </p>
            <div className="flex justify-between items-end mb-4" data-id="element-81">
              <span className="text-slate-500 line-through text-sm" data-id="element-82">
                Valor real: $58.000
              </span>
              <span className="text-3xl font-black text-white" data-id="element-83">
                $27.990 <span className="text-sm text-slate-500" data-id="element-84">ARS</span>
              </span>
            </div>
            <a href="https://www.nuevonivel.shop/cart/49840986226928:1" className="block text-center w-full bg-red-500 hover:bg-red-400 text-white font-black py-3 rounded-xl transition-colors" data-id="element-85">
              → QUIERO EL COMBO + PROTOCOLO
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400 font-medium" data-id="element-86">
          <span className="flex items-center gap-1.5" data-id="element-87">
            <Lock className="w-4 h-4 text-green-400" data-id="element-88" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-89">
            <Zap className="w-4 h-4 text-amber-400" data-id="element-90" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-91">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-92" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-93">
            <CreditCard className="w-4 h-4 text-blue-400" data-id="element-94" /> Mercado Pago —
            Tarjeta — Transferencia
          </span>
        </div>
      </div>
    </section>;
}